import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgArrowRight = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9, height: 7, viewBox: "0 0 9 7", fill: "none", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M0 3.5L7.5 3.5M7.5 3.5L5 1M7.5 3.5L5 6", stroke: "#CCCCCC", strokeWidth: 1.2 }) });
const ForwardRef = forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
